/**
 * assets/custom-faq.js
 * Accordion behavior for the Custom FAQ section.
 * No external libraries. Fully keyboard accessible (native <button>,
 * aria-expanded/aria-controls kept in sync).
 */
(function () {
  'use strict';

  function closeItem(item, btn) {
    item.setAttribute('data-open', 'false');
    btn.setAttribute('aria-expanded', 'false');
  }

  function openItem(item, btn) {
    item.setAttribute('data-open', 'true');
    btn.setAttribute('aria-expanded', 'true');
  }

  function initFaqSection(section) {
    if (section.dataset.faqEnhanced === 'true') return;
    section.dataset.faqEnhanced = 'true';

    var allowMultiple = section.dataset.allowMultiple === 'true';
    var buttons = section.querySelectorAll('[data-faq-toggle]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.custom-faq__item');
        var isOpen = item.getAttribute('data-open') === 'true';

        if (!allowMultiple) {
          section.querySelectorAll('.custom-faq__item').forEach(function (otherItem) {
            if (otherItem !== item) {
              var otherBtn = otherItem.querySelector('[data-faq-toggle]');
              closeItem(otherItem, otherBtn);
            }
          });
        }

        if (isOpen) {
          closeItem(item, btn);
        } else {
          openItem(item, btn);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.custom-faq').forEach(initFaqSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the Theme Editor re-renders this section
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.custom-faq');
    if (section) initFaqSection(section);
  });
})();
